import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar as BaseProgressBar } from 'react-bootstrap5';

export default function ProgressBar({ now }) {
  return (
    <BaseProgressBar
      now={now}
      label={`${now}%`}
      className={now === 100 ? 'primary-bar' : 'secondary-bar'}
    />
  );
}

ProgressBar.propTypes = {
  now: PropTypes.number.isRequired,
};
